// Currency symbol mapping for different exchanges
const currencySymbols = {
  // US Markets
  'US': { symbol: '$', name: 'US Dollar' },
  'NYSE': { symbol: '$', name: 'US Dollar' },
  'NASDAQ': { symbol: '$', name: 'US Dollar' },
  'AMEX': { symbol: '$', name: 'US Dollar' },
  'BATS': { symbol: '$', name: 'US Dollar' },
  'NCM': { symbol: '$', name: 'US Dollar' },
  'NGM': { symbol: '$', name: 'US Dollar' },
  'NYQ': { symbol: '$', name: 'US Dollar' },
  'OTC': { symbol: '$', name: 'US Dollar' },
  'PCX': { symbol: '$', name: 'US Dollar' },
  // Asian Markets
  'KS': { symbol: '₩', name: 'Korean Won' },
  'KQ': { symbol: '₩', name: 'Korean Won' },
  'KRX': { symbol: '₩', name: 'Korean Won' },
  'NS': { symbol: '₹', name: 'Indian Rupee' },
  'BO': { symbol: '₹', name: 'Indian Rupee' },
  'BSE': { symbol: '₹', name: 'Indian Rupee' },
  'NSE': { symbol: '₹', name: 'Indian Rupee' },
  'T': { symbol: '¥', name: 'Japanese Yen' },
  'TYO': { symbol: '¥', name: 'Japanese Yen' },
  'HK': { symbol: 'HK$', name: 'Hong Kong Dollar' },
  'HKSE': { symbol: 'HK$', name: 'Hong Kong Dollar' },
  'TW': { symbol: 'NT$', name: 'Taiwan Dollar' },
  'TWO': { symbol: 'NT$', name: 'Taiwan Dollar' },
  'BK': { symbol: '฿', name: 'Thai Baht' },
  'SET': { symbol: '฿', name: 'Thai Baht' },
  'ID': { symbol: 'Rp', name: 'Indonesian Rupiah' },
  'JKT': { symbol: 'Rp', name: 'Indonesian Rupiah' },
  'SI': { symbol: 'S$', name: 'Singapore Dollar' },
  'SGX': { symbol: 'S$', name: 'Singapore Dollar' },
  'MY': { symbol: 'RM', name: 'Malaysian Ringgit' },
  'KLSE': { symbol: 'RM', name: 'Malaysian Ringgit' },
  'PH': { symbol: '₱', name: 'Philippine Peso' },
  'PSE': { symbol: '₱', name: 'Philippine Peso' },
  'VN': { symbol: '₫', name: 'Vietnamese Dong' },
  'VNSE': { symbol: '₫', name: 'Vietnamese Dong' },
  // European Markets
  'L': { symbol: '£', name: 'British Pound' },
  'LSE': { symbol: '£', name: 'British Pound' },
  'PA': { symbol: '€', name: 'Euro' },
  'PAR': { symbol: '€', name: 'Euro' },
  'F': { symbol: '€', name: 'Euro' },
  'FRA': { symbol: '€', name: 'Euro' },
  'BE': { symbol: '€', name: 'Euro' },
  'BER': { symbol: '€', name: 'Euro' },
  'MC': { symbol: '€', name: 'Euro' },
  'MI': { symbol: '€', name: 'Euro' },
  'MIL': { symbol: '€', name: 'Euro' },
  'AMS': { symbol: '€', name: 'Euro' },
  'AS': { symbol: '€', name: 'Euro' },
  'BR': { symbol: '€', name: 'Euro' },
  'BRU': { symbol: '€', name: 'Euro' },
  'MAD': { symbol: '€', name: 'Euro' },
  'XETRA': { symbol: '€', name: 'Euro' },
  'XTRA': { symbol: '€', name: 'Euro' },
  'VI': { symbol: '€', name: 'Euro' },
  'VIE': { symbol: '€', name: 'Euro' },
  'LS': { symbol: '€', name: 'Euro' },
  'HE': { symbol: '€', name: 'Euro' },
  'HEL': { symbol: '€', name: 'Euro' },
  'DU': { symbol: '€', name: 'Euro' },
  'AT': { symbol: '€', name: 'Euro' },
  'ATH': { symbol: '€', name: 'Euro' },
  'LIS': { symbol: '€', name: 'Euro' },
  'CO': { symbol: 'kr', name: 'Danish Krone' },
  'CPH': { symbol: 'kr', name: 'Danish Krone' },
  'ST': { symbol: 'kr', name: 'Swedish Krona' },
  'STO': { symbol: 'kr', name: 'Swedish Krona' },
  'OL': { symbol: 'kr', name: 'Norwegian Krone' },
  'OSL': { symbol: 'kr', name: 'Norwegian Krone' },
  'IC': { symbol: 'kr', name: 'Icelandic Króna' },
  'ICE': { symbol: 'kr', name: 'Icelandic Króna' },
  'SW': { symbol: 'CHF', name: 'Swiss Franc' },
  'SWX': { symbol: 'CHF', name: 'Swiss Franc' },
  'IS': { symbol: '₺', name: 'Turkish Lira' },
  'IST': { symbol: '₺', name: 'Turkish Lira' },
  'PR': { symbol: 'Kč', name: 'Czech Koruna' },
  'WAR': { symbol: 'zł', name: 'Polish Złoty' },
  'WA': { symbol: 'zł', name: 'Polish Złoty' },
  'WSE': { symbol: 'zł', name: 'Polish Złoty' },
  'BUD': { symbol: 'Ft', name: 'Hungarian Forint' },
  // American Markets (non-US)
  'TO': { symbol: 'C$', name: 'Canadian Dollar' },
  'TSE': { symbol: 'C$', name: 'Canadian Dollar' },
  'TSX': { symbol: 'C$', name: 'Canadian Dollar' },
  'V': { symbol: 'C$', name: 'Canadian Dollar' },
  'TSXV': { symbol: 'C$', name: 'Canadian Dollar' },
  'CNQ': { symbol: 'C$', name: 'Canadian Dollar' },
  'NEO': { symbol: 'C$', name: 'Canadian Dollar' },
  'MX': { symbol: 'MX$', name: 'Mexican Peso' },
  'BMV': { symbol: 'MX$', name: 'Mexican Peso' },
  'BA': { symbol: 'ARS$', name: 'Argentine Peso' },
  'BCBA': { symbol: 'ARS$', name: 'Argentine Peso' },
  'SAO': { symbol: 'R$', name: 'Brazilian Real' },
  'BVMF': { symbol: 'R$', name: 'Brazilian Real' },
  'SA': { symbol: 'R$', name: 'Brazilian Real' },
  'CL': { symbol: 'CLP$', name: 'Chilean Peso' },
  'SN': { symbol: 'CLP$', name: 'Chilean Peso' },
  'CR': { symbol: '₡', name: 'Costa Rican Colón' },
  'SNSE': { symbol: '$', name: 'Colombian Peso' },
  'BVC': { symbol: '$', name: 'Colombian Peso' },
  'LM': { symbol: '$U', name: 'Uruguayan Peso' },
  'LIMA': { symbol: 'S/', name: 'Peruvian Sol' },
  'BVL': { symbol: 'S/', name: 'Peruvian Sol' },
  // Oceania Markets
  'AX': { symbol: 'A$', name: 'Australian Dollar' },
  'ASX': { symbol: 'A$', name: 'Australian Dollar' },
  'NZ': { symbol: 'NZ$', name: 'New Zealand Dollar' },
  'NZE': { symbol: 'NZ$', name: 'New Zealand Dollar' },
  'NZX': { symbol: 'NZ$', name: 'New Zealand Dollar' },
  // African Markets
  'JO': { symbol: 'R', name: 'South African Rand' },
  'JSE': { symbol: 'R', name: 'South African Rand' },
  // 'SA': { symbol: 'R', name: 'South African Rand' },
  'TU': { symbol: 'DT', name: 'Tunisian Dinar' },
  'CASE': { symbol: 'E£', name: 'Egyptian Pound' },
  'CA': { symbol: 'E£', name: 'Egyptian Pound' },
  'BC': { symbol: 'DA', name: 'Algerian Dinar' },
  'MOSE': { symbol: 'Dh', name: 'Moroccan Dirham' },
  // Middle Eastern Markets
  'TA': { symbol: '₪', name: 'Israeli Shekel' },
  'TASE': { symbol: '₪', name: 'Israeli Shekel' },
  // 'JO': { symbol: 'JD', name: 'Jordanian Dinar' },
  'QA': { symbol: 'ر.ق', name: 'Qatari Riyal' },
  'QE': { symbol: 'ر.ق', name: 'Qatari Riyal' },
  'KW': { symbol: 'د.ك', name: 'Kuwaiti Dinar' },
  'KSE': { symbol: 'د.ك', name: 'Kuwaiti Dinar' },
  // 'DU': { symbol: 'د.إ', name: 'UAE Dirham' },
  'DFMGI': { symbol: 'د.إ', name: 'UAE Dirham' },
  'AD': { symbol: 'د.إ', name: 'UAE Dirham' },
  'ADSMI': { symbol: 'د.إ', name: 'UAE Dirham' },
  'MSM': { symbol: 'ر.ع', name: 'Omani Rial' },
  'MSCI': { symbol: 'ر.ع', name: 'Omani Rial' },
  'BAX': { symbol: '.د.ب', name: 'Bahraini Dinar' },
  // Other Asian Markets
  'SZ': { symbol: '¥', name: 'Chinese Yuan' },
  'SHE': { symbol: '¥', name: 'Chinese Yuan' },
  'SS': { symbol: '¥', name: 'Chinese Yuan' },
  'SHA': { symbol: '¥', name: 'Chinese Yuan' },
  'SHG': { symbol: '¥', name: 'Chinese Yuan' },
  'RU': { symbol: '₽', name: 'Russian Ruble' },
  'ME': { symbol: '₽', name: 'Russian Ruble' },

  'MCX': { symbol: '₽', name: 'Russian Ruble' },
  'MOEX': { symbol: '₽', name: 'Russian Ruble' },
  // Default
  'DEFAULT': { symbol: '$', name: 'US Dollar' }
};

// Function to detect the currency symbol based on ticker
const getCurrencySymbol = (ticker) => {
  // Check if ticker contains an exchange suffix (e.g., 005930.KS)
  const parts = ticker.split('.');
  if (parts.length > 1) {
    const exchange = parts[parts.length - 1].toUpperCase(); // Convert to uppercase for case-insensitive matching
    return currencySymbols[exchange] || currencySymbols.DEFAULT;
  }
  
  // For common US stocks without suffix
  return currencySymbols.DEFAULT;
};

export { currencySymbols, getCurrencySymbol }; 